/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../../../../core/enums';
import { RootState, useTivoSelector } from '../../../../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../../../../common';

import './PinEntryCellInteractiveLayer.scss';

interface IPinEntryCellInteractiveLayerProps {
    focused: boolean;
}

const PinEntryCellInteractiveLayer: FunctionComponent<IPinEntryCellInteractiveLayerProps> = ({
    focused,
}): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    return (
        <React.Fragment>
            <Caret
                className={`pin-entry-cell-caret-north ${!focused ? 'pin-entry-hide-caret' : ''}`}
                direction={InteractiveComponents.NORTH}
                visible={focused}
                active={activeComponent === InteractiveComponents.NORTH}
            />
            <Caret
                className={`pin-entry-cell-caret-south ${!focused ? 'pin-entry-hide-caret' : ''}`}
                direction={InteractiveComponents.SOUTH}
                visible={focused}
                active={activeComponent === InteractiveComponents.SOUTH}
            />
        </React.Fragment>
    );
};

export default PinEntryCellInteractiveLayer;
